<template>
  <div
    v-ripple
    tabindex="0"
    class="zoox-component zoox-menu-option"
    :class="{disabled}"
    @keydown.enter.self="$emit('click')"
    @click="$emit('click')"
    @mouseenter="isHovering = true"
    @mouseleave="isHovering = false"
    @focus="isHovering = true"
    @blur="isHovering = false"
  >
    <div class="menu-icon" :style="{'background-color': iconBgColor}">
      <z-icon dark size="20"> {{ icon }} </z-icon>
    </div>

    <div class="title-wrapper overflow-hidden">
      <transition-group appear name="slide-in">
        <div
          key="title"
          class="body3-bold title-container"
          :class="{truncate: isHovering}"
        >
          {{ title }}
        </div>

        <v-clamp
          v-if="isHovering"
          key="desc"
          autoresize
          class="menu-description"
          :max-lines="2"
        >
          {{ description }}
        </v-clamp>
      </transition-group>
    </div>

    <v-scroll-x-transition>
      <div v-if="isRoute" class="flex-grow-1 d-flex justify-end">
        <div class="favorite-icon">
          <z-icon
            size="17"
            color="var(--black)"
            @click.stop="$emit('favorite')"
          >
            {{ isFavorite ? '$star_rounded' : '$star' }}
          </z-icon>
        </div>
      </div>

      <div v-else-if="isHovering" class="flex-grow-1 d-flex justify-end">
        <div class="foward-icon">
          <z-icon size="24"> $keyboard_arrow_right </z-icon>
        </div>
      </div>
    </v-scroll-x-transition>
  </div>
</template>

<script>
import VClamp from 'vue-clamp'

export default {
  components: {
    VClamp,
  },
  props: {
    title: {
      type: String,
      default: 'Titulo default',
    },

    description: {
      type: String,
      default: 'Descrição default',
    },

    isFavorite: {
      type: Boolean,
      default: false,
    },

    isRoute: {
      type: Boolean,
      default: false,
    },

    iconBgColor: {
      type: String,
      default: 'var(--primary)',
    },

    icon: {
      type: String,
      default: '$home',
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isHovering: false,
    }
  },
}
</script>

<style scoped lang="scss">
.zoox-menu-option {
  position: relative;
  padding: 15px;
  border-radius: var(--semantic-radius-rounded);
  display: flex;
  gap: 15px;
  align-items: center;
  background-color: var(--white);
  height: 72px;
  transition: background-color 250ms ease-in-out;
  cursor: pointer;

  &:hover {
    background-color: var(--black-100);
  }

  &.disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
}

.title-container {
  line-height: 15px;
  &.truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.menu-description {
  font-weight: 400;
  font-size: 11px;
  line-height: 13px;
  color: var(--black);
}

.menu-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  padding: 5px;
  height: 42px;
  min-width: 42px;
  width: 42px;
}

.favorite-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;

  &:hover {
    transition: background-color 250ms ease-in-out;
    background-color: var(--white);
  }
}

.slide-in-move,
.slide-in-enter-active,
.slide-in-leave-active {
  transition: opacity 0.3s cubic-bezier(0.25, 0.8, 0.5, 1),
    transform 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

.slide-in-enter,
.slide-in-leave-to {
  opacity: 0;
  transform: translateY(15px);
}

.slide-in-leave-active {
  display: none;
}
</style>
